import {  Paths, GetAzurePath, AzurePaths } from '../components/common/Constants';
import Request from '../components/common/Request';
import {
    Card,
    Table,
    Stack,
    Avatar,
    Button,
    Checkbox,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    TableContainer,
    TablePagination,
    ToggleButtonGroup,
    ToggleButton,
    Grid  
} from '@mui/material';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { useRequireAuth } from "../components/common/use-require-auth.js";
import Loading from "../components/common/loading.js";
import Page from '../components/Page';
import {  useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';



export default function Video(){
    var isAuth = useRequireAuth();

    const {t} = useTranslation();
    const [media, setMedia] = useState([]);
    const [fsMedia, setFsMedia] = useState(null);
    useEffect(async () =>{
    
        var result = await Request.Get(Paths.Media );
        if (result.ok){
            setMedia(result.data.Items);
        } 
      

    
      }, []);

    if (!isAuth){
     return <Loading></Loading>
    }
    return <Page className="videoPage">
        <Container>
         
            <Typography variant="h1" gutterBottom>
              { t("Gallery") } 
            </Typography>
        {/* {media.map(p => {
            if (p.EncryptedSymmetricKey == ''){
                return <video preload="none" controlsList="nodownload nofullscreen noremoteplayback" fullscreen width="100%" heigth="auto" key={p.MediaId} poster={p.PreviewUrl} onClick={e => { 
                    var player = e.target;
                    if (player.paused){
                        player.play();
                        player.setAttribute("controls", true);
                        
                    }
                    else{
                        player.pause();
                        player.setAttribute("controls", false);
                    }
                
                
                }}>
                    <source src={p.FileUrl}></source>
                </video>;
            }
            return "";  })} */}
        <Grid container spacing={2}>
        {media.map(p => {
            if (p.EncryptedSymmetricKey == ''){
                return <Grid  key={p.MediaId} item xs={12} md={6} lg={6}  onError={ev => {console.log(ev); ev.currentTarget.classList.add("hidden");}} >
                    <div className="video"  onClick={ (ev) => setFsMedia(p)}> 
                        <img className="videoPreview" src={p.PreviewUrl} />
                        <div className="playButton"></div>
                    </div>
                    </Grid>
            }
            return "";  })}
        </Grid>
        {
            fsMedia != null && <div className="videoOverlay">
                <video  controls autoPlay  width="100%" heigth="auto"
                //controlsList="nofullscreen noremoteplayback" 
                    // onClick={e => { 
                    // var player = e.target;
                    // if (player.paused){
                    //     player.play();
             
                        
                    // }
                    // else{
                    //     player.pause();
                 
                    // }}}
                    >
                    <source src={fsMedia.FileUrl}></source>
                </video>
                <CloseIcon className="close" onClick={()=> { setFsMedia(null) }}></CloseIcon>
                {/* <div className="close" >close</div> */}
            </div>
        }
        </Container>
    </Page>
}